import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {BaseService} from '../../base.service';
import {SliderService} from '../../services/slider.service';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {SliderDto} from '../../dto/slider.dto';
import { Slider } from '../../models/slider';
import { AngularFireStorage } from 'angularfire2/storage';
import { Env } from '../../env';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../../environments/environment';
import { finalize } from 'rxjs/operators';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: []
})
export class SliderComponent implements OnInit {
  
  @ViewChild('fileinput') fileinput: ElementRef;
  @ViewChild('elemento') spinner: SpinnerComponent;
  
  private titleComponent: string;
  private titlePanel: string;

  // upload
  private folder: string;
  private externalFileName: string;
  private textTitle: string;
  private b64Image: string;

  private sliderForm = this.fb.group({
    title: [''],
    message: ['']
  });

  constructor(
    private baseService: BaseService,
    private service: SliderService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private storage: AngularFireStorage, 
    private global: Env, 
    private toastr: ToastrService,
  ) {}
  slide:Slider = {
    id: 0,
    image: "",
    status: true,
    title: "",
    message: "",
    creationDate: "",
    creationUser: {
      creationDate: "",
      creationUser: "",
      fullName: "",
      email: "",
      phone: "",
    },
  };
  loadingMensaje:string = "";
  loadingRequest:boolean =  false;
  
  albumThumbURLs:string = "";
  albumThumbFile: File = null;
  
  loading( status:boolean , men:string = "" ){
    this.loadingMensaje = men;
    this.loadingRequest = status;
  }
  ngOnInit() {
    this.titleComponent = 'Sliders';
    this.titlePanel = 'Detalle de Slider';
    this.baseService.changedComponentName(this.titleComponent);

    this.textTitle = 'Sube la imagen aquí';
    this.folder = 'slider';
    this.externalFileName = '';
    let id = this.route.snapshot.paramMap.get("id");
    this.get(parseInt(id));
  }
  /*
  onSubmit(): void {
    if (!this.b64Image) {
      this.b64Image = 'default.png';
    }

    const dto = new SliderDto(this.sliderForm.get('title').value, this.sliderForm.get('message').value, this.b64Image);
    this.service.create(dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.baseService.showSuccess('Registro exitoso');
          this.router.navigate(['/dashboard/sliders']);
        });
      }
    }, error => {
      console.log(error);
      this.baseService.showError('General Error');
    });
  }
  */

  get(id:number = 0){
    this.service.get(id).subscribe(r=>{
      console.log(r);
      this.slide = r;
      this.albumThumbURLs = `${environment.URL_IMAGE_BASE}${environment.env}%2f${this.global.FOLDER_IMAGES['Slider']}%2f`+this.slide.image+`${environment.URL_IMAGE_SUFFIX}`;
    })
  }
  getUploadedImage(img: string): void {
    this.b64Image = img;
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(){
    //console.log(this.bankForm.value.name);
    // si albumThumbFile es null solo sube la data
    console.log(this.sliderForm.value.title,this.sliderForm.value.message);
    if ( !(this.sliderForm.value.title > '' )) {
      this.showError('El slide debe tener un nombre.');
    } else if ( !(this.sliderForm.value.message > '' )) {
      this.showError('El slide debe tener un mensaje.');
    } else { 
      if ( this.albumThumbFile ) {
      //this.showError('El slide debe tener una imagen.');
      this.loading(true, "Subiendo imagen...");
      //this.showSuccess("Banco Registrado");
      let blobName = "slide-"+this.slide.id;
      let extensionName = this.albumThumbFile.name.split('.').pop();
      let filePath = `${environment.env}/${this.global.FOLDER_IMAGES['Slider']}/${blobName}.${extensionName}`;
      let ref = this.storage.ref(filePath);
      
      let task = this.storage.upload(filePath, this.albumThumbFile );
      //ref.getDownloadURL( r => {console.log(r);} );
      task.snapshotChanges().pipe(
        finalize(() => {
          this.loading(true, "Actualizando...");
          let downloadURL = ref.getDownloadURL()
          downloadURL.subscribe( url => { 
            console.log( url );
            this.albumThumbFile = null;
              this.service.update( this.slide.id , blobName+'.'+extensionName , this.sliderForm.value.title , this.sliderForm.value.message).subscribe( r => {
                //poner mensaje de exito
                //console.log('r',r);
                this.loading(false);
                this.showSuccess("Información actualizada con éxito.");
                //this.get(parseInt(this.route.snapshot.paramMap.get("id")));
                this.router.navigate(['/dashboard/sliders']);
                //this.get(this.bank.id);
              }, err => {
                this.loading(false);
                this.showError("Hubo un error en el servidor");
              });
            });
        })
      ).subscribe();
      } else {
        this.loading(true, "Actualizando...");
            console.log( this.albumThumbURLs );
            this.albumThumbFile = null;
              this.service.update( this.slide.id , this.slide.image , this.sliderForm.value.title , this.sliderForm.value.message).subscribe( r => {
                //poner mensaje de exito
                //console.log('r',r);
                this.showSuccess("Información actualizada con éxito.");
                this.loading(false);
                this.router.navigate(['/dashboard/sliders']);
                //this.get(this.bank.id);
              }, err => {
                this.showError("Hubo un error en el servidor");
                this.loading(false);
              });
      }
    }
    
    
  }

  
  showSuccess(message: string): any {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
    this.loading(false);
  }

  showError(message: string): any {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
    this.loading(false);
  }

  updateSinglePic($event){
    let files:FileList = $event.target  .files;
    let r = files[0];
    this.albumThumbFile = r;
    let reader = new FileReader(); 
    reader.readAsDataURL(r);
    reader.onload = (_event) => {
      let co = reader.result;
      console.log(co);
      this.albumThumbURLs = <string>co; 
    }
    this.fileinput.nativeElement.value = "";
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/slider/slider.component.ts